import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { User } from '@jungles/shared';
import { api } from '../lib/api';
import { useSession, useUser } from '../app/session';
import { useToast } from '../app/toast';
import { BackLink, Header, Screen, TabBar } from '../components/Chrome';

/** A1 · Участие и приватность (SPEC §5). */

export function PrivacyScreen() {
  const user = useUser();
  const { updateUser } = useSession();
  const navigate = useNavigate();
  const toast = useToast();

  const [consent, setConsent] = useState(user.publicConsent);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try {
      const next = await api.patch<User>('/api/me', { publicConsent: consent });
      updateUser(next);
      toast('Настройка участия сохранена');
      navigate('/arena');
    } catch (err) {
      toast(err instanceof Error ? err.message : 'Не удалось сохранить');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Screen tabs>
      <Header />
      <BackLink to="/profile" label="Профиль" />
      <h1>Участие и приватность</h1>

      <section className="card">
        <h2>Что видно другим</h2>
        <p>
          <b>Публично при согласии:</b> имя и игровые очки в таблице лиги.
        </p>
        <p>
          <b>Не публикуется никогда:</b> упражнения, подходы, веса и питание.
        </p>
        <p className="nt">
          Без согласия вы всё равно участвуете в лигах, но в таблице отображаетесь как
          «Участник» — без имени и без зала.
        </p>

        <label className="fl">
          <input
            className="cb"
            type="checkbox"
            checked={consent}
            onChange={(event) => setConsent(event.target.checked)}
          />
          Хочу показывать имя и очки
        </label>

        <button className="b p wide" type="button" onClick={() => void save()} disabled={busy}>
          Сохранить участие
        </button>
      </section>

      <TabBar />
    </Screen>
  );
}
